const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng-fe/public_method');

const thumbnailsHandle = (thumbnails, thumbnail, w, h) => {
    let url = '';

    if (thumbnail) {
        url = thumbnail;
    } else if (thumbnails && thumbnails.image && thumbnails.image[0]) {
        url = thumbnails.image[0].url;
    }

    return formatImage(url, w, h);
};

/**
* 格式化作者推荐数据，按照每5个一帧
* @param {Array} dataArray 结构化碎片数据
*/
const formatAuthorRecData = dataArray => {
   const returnArr = [];

   for (let i = 0; i < Math.ceil(dataArray.length / 5); i++) {
       returnArr.push(dataArray.slice(i * 5, i * 5 + 5));
   }

   return returnArr;
};

/**
 *
 * @param {*} data 单条数据。 返回 对象link。
 * 根据data里type类型，重新返回跳转客户端内的数据(特定type, idOrUrl 属性) 对象link（object）
 * http://know.ifengidc.com/pages/viewpage.action?pageId=15499640#app-switcher
 */
const GETLINKTYPE = (data) => {
    try {
        if (!Object.prototype.toString.call(data)) {
            return {};
        }

        const _linkDatas = {
            type: data.type,
            idOrUrl: '',
        };

        if (_linkDatas.type === 'web') {
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = data.url;
        } else if (_linkDatas.type === 'topic2') {
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = `https://api.iclient.ifeng.com/TopicApiForCmpp?topicid=${data.topicid}`;
        } else if (_linkDatas.type === 'doc' || _linkDatas.type === 'article') {
            _linkDatas.type = 'doc';
            _linkDatas.idOrUrl = `ucms_${data.base62Id}`;
        } else if (
               _linkDatas.type === 'video'
            || _linkDatas.type === 'phvideo'
        ) {
            _linkDatas.type = 'phvideo';
            _linkDatas.idOrUrl = data.guid;
        } else if (_linkDatas.type === 'videoshortimg') {
            // 其他需要guid的类型
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = data.guid;
        } else {
            // 其他需要ucms_base62Id的类型
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = `ucms_${data.base62Id}`;
        }

        return _linkDatas;
    } catch (e) {
        console.error(e);
    }
};

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    handleFinanceListPicData: data => {
        return data.slice(0, 5).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleFeedRecomListInfo: data => {
        return data.map(item => ({
            url: formatUrl(item.url),
            thumbnails:
            (item.thumbnail && formatImage(item.thumbnail, 192, 108)) || (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                ? formatImage(item.thumbnails.image[0].url, 192, 108)
                : ''),
            title: item.title || '',
            summary: item.summary || '',
            commentNum: 1,
            newsTime:
                item.newsTime &&
                `${item.newsTime.split(' ')[0].split('-')[1]}-${item.newsTime.split(' ')[0].split('-')[2]} ${item.newsTime.split(' ')[1].split(':')[0]}:${item.newsTime.split(' ')[1].split(':')[1]}`,
            commentUrl: item.commentUrl &&
                        `https://gentie.ifeng.com/view.html?docUrl=${item.commentUrl}&docName=${encodeURIComponent(item.title)}&skey=${item.skey}&pcUrl=${item.url}`,
        }));
    },
    // 旅人首页banner图
    handleLvrenBannerPicData: data => {
        const fliterData = data.filter(item => item.url && item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
            ||
           item.url && item.thumbnail
        );

        return fliterData.slice(0, 5).map(item => ({
                url: formatUrl(item.url),
                title: item.title,
                summary: item.summary,
                thumbnails: thumbnailsHandle(item.thumbnails, item.thumbnail, 1000, 472),
            }));
    },
    // 旅游首页
    handleTravelBannerPicData: data => {
        return data.slice(0, 5).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            summary: item.summary,
            thumbnails: thumbnailsHandle(item.thumbnails, item.thumbnail, 1000, 380)
        }));
    },
    handleTravelNewsData: data => {
        return data.map(item => ({
            title: item.title,
            summary: item.summary,
            url: formatUrl(item.url),
            newsTime: item.newsTime,
            thumbnails: thumbnailsHandle(item.thumbnails, item.thumbnail, 109, 73)
        }));
    },
    handleTravelFocusNewsData: data => {
        return data.slice(0, 6).map(item => ({
            title: item.title,
            url: formatUrl(item.url),
        }));
    },
    handleTravelGlobalGoData: data => {
        return data.slice(0, 2).map(item => ({
            id: item.id,
            url: formatUrl(item.url),
            thumbnails: thumbnailsHandle(item.thumbnails, item.thumbnail, 300, 132),
            summary: item.summary,
            title: item.title,
        }));
    },
    handleTravelGlobalGoAndChinaGlGData: data => {
        return data.slice(0, 4).map(item => ({
            id: item.id,
            url: formatUrl(item.url),
            thumbnails: thumbnailsHandle(item.thumbnails, item.thumbnail, 320, 212),
            summary: item.summary,
            title: item.title,
        }));
    },
    handleTravelGlobalGoAndChinaChData: data => {
        return data.slice(0, 4).map(item => ({
            id: item.id,
            url: formatUrl(item.url),
            thumbnails: thumbnailsHandle(item.thumbnails, item.thumbnail, 320, 212),
            summary: item.summary,
            title: item.title,
        }));
    },
    handleFengAuthorRecData: data => {
        return formatAuthorRecData(data);
    },

    // 青年首页
    imageCut: (item, index) => {
        switch (index) {
            case 0:
                return formatImage(item.thumbnail, 254, 310);
            case 6:
                return formatImage(item.thumbnail, 750, 270);
            default:
                return formatImage(item.thumbnail, 254, 150);
        }
    },

    handleYoungNewsData: data => {
        return recommendRandomSort(data, 7).map((item, index) => ({
            thumbnail: this.imageCut(item, index),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleTalkBannerPic: data => {
        return data.slice(0, 6).map(item => ({
            thumbnails:
                    (item.thumbnail && formatImage(item.thumbnail, 326, 300)) || (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                        ? formatImage(item.thumbnails.image[0].url, 326, 300)
                        : ''),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleMobileTalkFeed: data => {
        return data.slice(0, 4).map(item => ({
            thumbnails:
                    (item.thumbnail && formatImage(item.thumbnail, 140, 80)) || (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                        ? formatImage(item.thumbnails.image[0].url, 140, 80)
                        : ''),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleMobileTalkInfo: data => {
        return data;
    },
    handleGoodTalkInfo: data => {
        return data;
    },
    handleRankTalkInfo: data => {
        return data;
    },
    handleTopBannerInfo: data => {
        return data.map(item => ({
            thumbnail: (item.thumbnail && formatImage(item.thumbnail, 1000, 90)) || '',
            url: formatUrl(item.url),
            title: item.title || ''
        }))[0];
    },
    handleRightBottomInfo: data => {
        return data.map(item => ({
            thumbnail: (item.thumbnail && formatImage(item.thumbnail, 300, 250)) || '',
            url: formatUrl(item.url),
            title: item.title || ''
        }))[0];
    },
    handleGoodTalkFeed: data => {
        return data.slice(0, 3).map(item => ({
            thumbnails:
                    (item.thumbnail && formatImage(item.thumbnail, 97, 95)) || (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                        ? formatImage(item.thumbnails.image[0].url, 97, 95)
                        : ''),
            url: formatUrl(item.url),
            title: item.title.length > 26 ? `${item.title.slice(0, 25)}......` : item.title,
            summary: item.summary.length > 25 ? `${item.summary.slice(0, 25)}......` : item.summary,
        }));
    },
    handleSlideDmNewsList: data => {
        return data.map(item => ({
            thumbnails:
                    (item.thumbnail && formatImage(item.thumbnail, 870, 415)) || (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                        ? formatImage(item.thumbnails.image[0].url, 870, 415)
                        : ''),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleTwoPicDmNewsList: data => {
        return data.slice(0, 2).map(item => ({
            thumbnails:
                    (item.thumbnail && formatImage(item.thumbnail, 300, 185)) || (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0]
                        ? formatImage(item.thumbnails.image[0].url, 300, 185)
                        : ''),
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    // 火力无限 home page
    handleHLWXHomeSlideInfo: data => {
        try {
            return data.slice(0, 3).map(item => ({
                type: item.type,
                guid: item.guid || '',
                link: GETLINKTYPE(item),
                title: (item.title && item.title.length > 18) ? `${item.title.slice(0, 18)}...` : (item.title || ''),
                src: (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0].url && formatImage(item.thumbnails.image[0].url, 750, 375)) || (item.thumbnail && formatImage(item.thumbnail, 750, 375)) || '',
                url: item.url || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHLWXHomeMomentsInfo: data => {
        try {
            return data.slice(0, 4).map( item => ({
                type: item.type,
                guid: item.guid || '',
                link: GETLINKTYPE(item),
                title: item.title || '',
                src: (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0].url && formatImage(item.thumbnails.image[0].url, 342, 250)) || (item.thumbnail && formatImage(item.thumbnail, 342, 250)) || '',
                url: item.url || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHLWXHomePastVideos: data => {
        try {
            return data.slice(0, 3).map( item => ({
                type: item.type,
                guid: item.guid || '',
                commentUrl: item.commentUrl || '',
                link: GETLINKTYPE(item),
                title: item.title || '',
                src: (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0].url && formatImage(item.thumbnails.image[0].url, 230, 164)) || (item.thumbnail && formatImage(item.thumbnail, 230, 164)) || '',
                url: item.url || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHLWXHomeExpertMTs: data => {
        try {
            return data.slice(0, 6).map( item => ({
                type: item.type,
                guid: item.guid || '',
                link: GETLINKTYPE(item),
                title: item.title || '',
                src: (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0].url && formatImage(item.thumbnails.image[0].url, 112, 112)) || (item.thumbnail && formatImage(item.thumbnail, 112, 112)) || '',
                url: item.url || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleGuideBanner: data => {
        try {
            return {
                image: (data && data.image) || ''
            };
        } catch (error) {
            console.error(error);
        }

        return data;
    },
};
